export const placeholderImage = `${import.meta.env['VITE_MEDIA_URL']}/article/placeholder.webp`;

// Types d'options cloudimage
export type CloudimageGravity =
  | 'northwest'
  | 'north'
  | 'northeast'
  | 'west'
  | 'center'
  | 'centre'
  | 'east'
  | 'southwest'
  | 'south'
  | 'southeast'
  | 'auto'
  | 'face'
  | 'smart'
  | 'trim'
  | `${number},${number}`;

export interface ImageOptimisationOptions {
  // Hauteur cible (utilisée avec width pour activer le crop côté Cloudimage)
  height?: number;
  // Gravité du recadrage
  gravity?: CloudimageGravity;
  // N'agrandit jamais l'image (`org_if_sml`) : plus petite que la largeur demandée, elle est
  // servie à sa taille, mesurée après découpe et rotation. Agrandie, elle serait plus lourde
  // sans être plus nette.
  sans_agrandir?: boolean;
}

export function imageOptimisee(
  srcUrl: string | undefined,
  width: number,
  options?: ImageOptimisationOptions,
) {
  if (!srcUrl) {
    return placeholderImage;
  }
  const sep = srcUrl.includes('?') ? '&' : '?';

  const params = new URLSearchParams();
  // Cloudimage attend width/height pour le redimensionnement & crop
  params.set('width', String(width));
  if (typeof options?.height === 'number') {
    params.set('height', String(options.height));
    if (options.gravity) {
      params.set('gravity', options.gravity);
    }
  }
  // Demande à Cloudimage de ne pas agrandir l'image : si elle est plus petite que `width` (une fois
  // découpée et tournée), elle est servie à sa taille. `org_if_sml` (« original if smaller ») est le
  // nom imposé par Cloudimage ; mal écrit, il serait ignoré sans erreur.
  if (options?.sans_agrandir) {
    params.set('org_if_sml', '1');
  }

  return `${srcUrl}${sep}${params.toString()}`;
}

export function imageOptimiseeH(srcUrl: string | undefined, height: number) {
  if (!srcUrl) {
    return placeholderImage;
  }
  // Hypothèse forte que
  const sep = srcUrl.includes('?') ? '&' : '?';
  return `${srcUrl}${sep}height=${height}`;
}
